import * as React from 'react';

const { useState } = React;

export const Image: React.FC<{ src: string }> = ({ src }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoad = () => void setIsLoaded(true);

  return (
    <div className="shadow border-2 border-white mt-4 mb-6">
      <img
        src={src}
        onLoad={onLoad}
        className={`${!isLoaded ? 'opacity-0' : ''} align-bottom`}
        alt=""
      />
      {!isLoaded && <div className="loader h-48" />}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Tutorial/components/Image.tsx